export default __webpack_public_path__ + "static/media/logo.557b8328.svg";